// extracted by mini-css-extract-plugin
export default {"footer":"QuestionFinishedScreenForZoom_footer__TYptp","rightArrow":"QuestionFinishedScreenForZoom_rightArrow__7BrBG","container":"QuestionFinishedScreenForZoom_container__Yf1fr"};